import React from "react";
import BasicInfo from "./BasicInfo.js";
import JoinToNewsletter from "./JoinToNewsletter.js";
import SearchingUsOnline from "./SearchingUsOnline.js";
import classes from "./FooterComp.module.css";

export default function FooterComp() {
  return (
    <div className={`${classes.flexContainer} ${classes.flexDirection}`}>
      <BasicInfo />
      <JoinToNewsletter />
      <SearchingUsOnline />
    </div>
  );
}
